import * as React from 'react';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import { cn } from '@/components/TailwindComponents/lib/utils';

interface PriceInputProps extends React.ComponentProps<'input'> {
  className?: string;
}

const PriceInput = React.forwardRef<HTMLInputElement, PriceInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <div className="flex">
        <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600">
          <AttachMoneyIcon
            fontWeight={300}
            fontSize="small"
            htmlColor="#6B7280"
          />
        </span>
        <input
          ref={ref}
          {...props}
          type="number"
          step="0.01"
          min="0"
          className={cn(
            'rounded-none rounded-e-lg border text-gray-900 focus:ring-gray-500 focus:border-gray-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-500 dark:focus:border-gray-500',
            className,
          )}
        />
      </div>
    );
  },
);

PriceInput.displayName = 'PriceInput';

export { PriceInput };
